<section>
    <!-- Filter -->
    <div class="flex-between-center gap-y-3 gap-x-2 flex-wrap">
        <div class="flex-start-center gap-x-2 md:gap-x-3 overflow-y-visible max-md:overflow-x-auto">
            <div class="h-9 md:h-11 px-2.5 rounded-lg border border-line flex-center-center">
                <label
                    nz-checkbox
                    [(ngModel)]="smartMoneyChecked"
                    [nzDisabled]="!userAuthenticated"
                    class="max-md:text-[11px]"
                    (ngModelChange)="selectedSubscribedWatchlist = null"
                >
                    Smart Buys
                </label>
            </div>

            <div class="flex-start-center h-9 md:h-11 px-2 md:px-2.5 rounded-lg border border-line relative" [ngClass]="{'md:pr-[42px]': !isWatchListAdded}">
                <label
                    nz-checkbox
                    [(ngModel)]="myWatchListChecked"
                    [nzDisabled]="!userAuthenticated"
                    class="max-md:text-[11px]"
                    (ngModelChange)="selectedSubscribedWatchlist = null"
                >
                    My Watchlist
                </label>

                <div class="h-5 w-[1px] bg-line mx-3"></div>

                <div class="w-6 h-6 md:w-7 md:h-7">
                    <div
                        class="relative flex-center-center gap-x-1 w-6 h-6 md:w-7 md:h-7 rounded-md cursor-pointer bg-gradient"
                        [@tada]="bounceStatus"
                        (click)="goWatchList()"
                    >
                        <span nz-icon nzType="plus" class="text-xs md:text-lg" nzTheme="outline"></span>
                    </div>
                </div>

                <div *ngIf="!isWatchListAdded" class="bonus-watchlist-points">
                    <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                    <span>+100</span>
                </div>
            </div>

            <!-- 没有订阅的watchlist -->
            <div *ngIf="!mySubscribedWatchlist?.length" class="flex-start-center h-9 md:h-11 px-2 md:px-2.5 rounded-lg border border-line relative gap-x-1">
                <span class="max-md:text-[11px] whitespace-nowrap" [ngClass]="{'text-sub-text': !mySubscribedWatchlist?.length}">
                    My Subscribed Watchlist
                </span>

                <ng-container *ngIf="!mySubscribedWatchlist?.length">
                    <div class="h-5 w-[1px] bg-line mx-3"></div>

                    <div
                        class="relative flex-center-center gap-x-1 w-6 h-6 md:w-7 md:h-7 rounded-md bg-secondaryCard hover:bg-black transition-colors hover:text-white cursor-pointer"
                        [routerLink]="['/meme-dashboard/watchlist-marketplace']"
                    >
                        <span nz-icon nzType="plus" class="text-xs md:text-lg" nzTheme="outline"></span>
                    </div>
                </ng-container>

                <ng-container *ngIf="mySubscribedWatchlist?.length">
                    <span class="text-sm"> ({{mySubscribedWatchlist.length}}) </span>
                    <span nz-icon nzType="caret-down" class="text-sm" nzTheme="outline"></span>
                </ng-container>
            </div>

            <!-- 有订阅的watchlist -->
            <div class="watchlist-select w-fit">
                <nz-select
                    *ngIf="mySubscribedWatchlist?.length"
                    [(ngModel)]="selectedSubscribedWatchlist"
                    [nzDropdownMatchSelectWidth]="false"
                    [nzPlaceHolder]="'My Subscribed Watchlists ('+ mySubscribedWatchlist.length +')'"
                    (ngModelChange)="subscribedWatchlistChange()"
                    class="!h-9 md:!h-11 !text-sm md:!text-base"
                    [nzOptionHeightPx]="34"
                >
                    <!-- 添加头部选项 -->
                    <nz-option nzCustomContent nzDisabled [nzValue]="'description'">
                        <div class="text-sub-text text-xs max-w-[254px] whitespace-normal -mb-1 -mt-0.5">
                            Please select a watchlist you subscribe to for analysis
                        </div>
                    </nz-option>

                    <nz-option nzCustomContent *ngFor="let item of mySubscribedWatchlist" [nzValue]="item.id" [nzLabel]="item.name || 'Unnamed'">
                        <div class="flex-start-center gap-x-1">
                            <img
                                nzDisablePreview
                                nz-image
                                [nzSrc]="item.logo_url"
                                nzFallback="/assets/imgs/fallback.png"
                                class="w-[18px] h-[18px] rounded-full"
                                alt=""
                            />
                            <span class="text-sm">{{item.name || 'Unnamed'}}</span>
                            <span class="text-2xs">
                                <span class="text-sub-text">7D PNL</span>
                                <span [ngClass]="{'text-red-500': item.stats?.pnl_7d < 0, 'text-success': item.stats?.pnl_7d > 0}">
                                    {{(item.stats?.pnl_7d || 0) | kmb2:2}}
                                    <ng-container *ngIf="!!item.stats?.pnl_7d">
                                        {{(item.stats?.pnl_7d / item.stats?.buy_usd_7d) | percent: '1.0-2'}}</ng-container
                                    >
                                </span>
                            </span>
                        </div>
                    </nz-option>

                    <!-- 添加尾部选项 -->
                    <nz-option nzCustomContent nzDisabled [nzValue]="'marketplace'">
                        <button nz-button nzType="primary" class="!w-full -mb1" nzSize="small" [routerLink]="['/meme-dashboard/watchlist-marketplace']">
                            <span nz-icon nzType="plus" class="text-xs" nzTheme="outline"></span>
                        </button>
                    </nz-option>
                </nz-select>
            </div>
        </div>

        <nz-radio-group class="shrink-0 grow text-right" [(ngModel)]="dateRange">
            <label nz-radio-button *ngFor="let item of dateRangeList" [nzValue]="item.value">{{item.label}}</label>
        </nz-radio-group>
    </div>

    <div id="monad_testnet" class="pt-3 md:pt-6">
        <app-token-treemap-by-chain
            [chain]="'monad_testnet'"
            [dateRange]="dateRange"
            [valueType]="valueType"
            [selectedSubscribedWatchlist]="selectedSubscribedWatchlist"
            [smartMoneyChecked]="smartMoneyChecked"
            [myWatchListChecked]="myWatchListChecked"
        ></app-token-treemap-by-chain>
    </div>

    <div id="solana" class="pt-3 md:pt-6">
        <app-token-treemap-by-chain
            [chain]="'sol'"
            [dateRange]="dateRange"
            [valueType]="valueType"
            [selectedSubscribedWatchlist]="selectedSubscribedWatchlist"
            [smartMoneyChecked]="smartMoneyChecked"
            [myWatchListChecked]="myWatchListChecked"
        ></app-token-treemap-by-chain>
    </div>

    <div id="bsc" class="pt-3 md:pt-6">
        <app-token-treemap-by-chain
            [chain]="ChainEnum.BSC"
            [dateRange]="dateRange"
            [valueType]="valueType"
            [selectedSubscribedWatchlist]="selectedSubscribedWatchlist"
            [smartMoneyChecked]="smartMoneyChecked"
            [myWatchListChecked]="myWatchListChecked"
        ></app-token-treemap-by-chain>
    </div>

    <div id="base" class="pt-3 md:pt-6">
        <app-token-treemap-by-chain
            [chain]="ChainEnum.BASE"
            [dateRange]="dateRange"
            [valueType]="valueType"
            [selectedSubscribedWatchlist]="selectedSubscribedWatchlist"
            [smartMoneyChecked]="smartMoneyChecked"
            [myWatchListChecked]="myWatchListChecked"
        ></app-token-treemap-by-chain>
    </div>
</section>
